import { useEffect, useState } from "react";
import api from "@/lib/api";

/** The states and union territories (one spelling each) from the API, for state drop-downs. */
export default function useStates() {
  const [states, setStates] = useState([]);
  useEffect(() => {
    api.get("/states").then(({ data }) => setStates(data)).catch(() => {});
  }, []);
  return states;
}
